import { Col, Row } from "antd";
import React from "react";
import ThemedText from "../../../components/ThemedText/ThemedText";
import { BestSection } from "../../../data/Data";
import ThemedButton from "../../../components/Button/Button";
import { centerDiv } from "../../../styles/Format";
import { useMediaQuery } from "react-responsive";

export default function Best() {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    <div>
      <Row className="container">
        <Col span={isMobile ? 24 : 12}>
          <ThemedText
            style={{ fontSize: isMobile ? "2rem" : "3rem", fontWeight: "bold" }}
          >
            {BestSection.title}
          </ThemedText>
        </Col>
        <Col span={isMobile ? 24 : 12}>
          {isMobile && (
            <>
              <br />
              <br />
            </>
          )}
          <ThemedText>{BestSection.title2}</ThemedText>
        </Col>
      </Row>
      <br />
      <div className="container">
        <img
          src={BestSection.bg}
          style={{ width: "100%", objectFit: "contain" }}
        />
      </div>
    </div>
  );
}
